import { TerminalPane } from '@/components/desktop-panel-primitives';
import { PlacedTab } from '@/components/desktop-side-panel/placed-tab';
import type { TerminalSurface } from './platform-services';

/**
 * Host-owned PTY rendering selected through a declarative system-plugin contribution: the
 * terminals the panel shows, alone or each over its cell of the split.
 */
export function PlatformTerminalSurface({
  sessions,
  placements,
  onSelectSession,
  client,
  workspace,
  onAskSelectionInSideChat,
  onMoreDetailsSelection,
  onAnnotateSelection,
  onRenameSession,
}: TerminalSurface) {
  const hasVisibleSession = sessions.some((session) => placements.has(session.id));
  return (
    <div className={hasVisibleSession ? 'relative h-full' : 'hidden'}>
      {sessions.map((session) => (
        <PlacedTab
          id={session.id}
          key={session.id}
          onSelect={onSelectSession}
          placement={placements.get(session.id)}
        >
          <TerminalPane
            client={client}
            onAskSelectionInSideChat={onAskSelectionInSideChat}
            onMoreDetailsSelection={onMoreDetailsSelection}
            onReferenceSelection={(content, anchor) =>
              onAnnotateSelection({
                anchor,
                content,
                sourceId: session.id,
                sourceKind: 'terminal',
                sourceLabel: session.name,
              })
            }
            onTitleChange={(title) => {
              const name = title.trim();
              if (name) onRenameSession(session.id, name);
            }}
            session={session}
            workspace={workspace}
          />
        </PlacedTab>
      ))}
    </div>
  );
}
